import { useLayoutEffect } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../services/hooks/useReduxHooks";
import { closeAnimatedGlobalBanner } from "../../../services/redux/slices/globalComponentsToggleSlice";
import styles from "./AnimatedBanner.module.scss";

export const AnimatedGlobalBanner = () => {
  const dispatch = useAppDispatch();
  const globalBanner = useAppSelector(
    (state) => state.globalComponentsToggleSlice.animatedGlobalBanner
  );
  const closeBanner = () => {
    dispatch(closeAnimatedGlobalBanner());
  };

  useLayoutEffect(() => {
    if (globalBanner.isOpen) {
      const i = setTimeout(() => closeBanner(), 4000);

      return () => clearTimeout(i);
    }
  }, [globalBanner.isOpen]);

  return (
    <>
      {globalBanner.isOpen && (
        <div
          className={`${styles.global_banner} ${
            globalBanner.warning
              ? styles.warning_banner
              : globalBanner.info
              ? styles.info_banner
              : styles.success_banner
          }`}
        >
          <p data-testid="global-banner">{globalBanner.text}</p>
        </div>
      )}
    </>
  );
};
